import React from "react";
import NewTour from "@components/MonthlyTourPlan/NewTour";
import { PageHeader } from "@features/shared";
import { usePageInitialization } from "@features/shared/hooks/usePageInitialization";

/**
 * MonthlyTourPlan Page
 * Monthly tour planning and management
 *
 * Features:
 * - Create new tour plans with date selection
 * - Add WSS (Wholesale & Stock Point) to tours
 * - View upcoming tour plans
 * - Edit/Delete existing tours
 * - Territory and cluster-based planning
 *
 * Child Components:
 * - NewTour (2494 lines) – main form with UpcomingTourPlans, EditFormModal, etc.
 */
const MonthlyTourPlanPage = () => {
  usePageInitialization();

  return (
    <div>
      <PageHeader title="Monthly Tour Plan" path="/" />
      <div className="container bg-[#F5F5F5]">
        <NewTour />
      </div>
    </div>
  );
};

export default MonthlyTourPlanPage;
